import { useTheme } from "@mui/material/styles";
import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import { Tooltip, Typography, useMediaQuery } from "@mui/material";
import { Theme } from "@mui/system";
import { Breakpoint } from "@mui/system/createTheme/createBreakpoints";

type ComponentProps = {
  icon: React.ReactNode;
  text?: string;
  tooltip?: string;
  iconLocation?: "start" | "end";
  breakpoint?: Breakpoint | number;
};

export function ResponsiveButton(props: ComponentProps & ButtonProps) {
  const theme = useTheme();
  const { icon, text, iconLocation = "start", breakpoint = "xl", tooltip, ...rest } = props;

  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

  const buttonText = (
    <Typography variant={"button"} sx={{ ml: theme.spacing(1) }}>
      {text}
    </Typography>
  );

  return (
    <Tooltip title={<Typography variant="body1">{tooltip ?? text}</Typography>} arrow>
      <span>
        <Button {...rest}>
          {iconLocation === "start" ? icon : undefined}
          {matches ? buttonText : undefined}
          {iconLocation === "end" ? icon : undefined}
        </Button>
      </span>
    </Tooltip>
  );
}
